import React, { useEffect, useState } from "react";
import { useDarkMode } from "usehooks-ts";
import Logo from "../../assets/images/sidebarLogo.png";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";
import { ReactComponent as MenuIcon } from "../../assets/icons/menu.svg";
import { ReactComponent as MenuIcon2 } from "../../assets/icons/menu2.svg";

import { ReactComponent as MoonIcon } from "../../assets/icons/moon.svg";
import { ReactComponent as SunIcon } from "../../assets/icons/sun.svg";
import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { ReactComponent as Home } from "../../assets/icons/home.svg";
import { ReactComponent as Live } from "../../assets/icons/live.svg";
import { ReactComponent as Pair } from "../../assets/icons/liveexplorer.svg";
import { AnimatePresence, motion } from "framer-motion";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Menu from "../../assets/images/menu.png";
import BitChain from "../../assets/images/LogoImg.png";
import PayWing from "../../assets/images/paywing.png";

import "./Navigation.scss";
import Dropdown from "../Dropdown";
import Loogo from "../../assets/images/logo.png";

import styled from "styled-components";

const Button = styled.button`
  background-color: #0a090256;
  color: #ffba00;
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 20px;
  margin-right: 10px;
  cursor: pointer;
  border: none;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2); /* Add a subtle box shadow */
  transform: translateY(0px); /* Reset the translateY */
  transition: transform 0.2s, box-shadow 0.2s; /* Add smooth transition effects */

  &:hover {
    transform: translateY(-2px); /* Move the button up slightly on hover */
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3); /* Increase the box shadow on hover for a more pronounced 3D effect */
  }
`;

const Navigation: React.FC = () => {
  const { isDarkMode, toggle } = useDarkMode();
  const [openClose, setOpenClose] = useState(false);
  const [openCloses, setOpenCloses] = useState(false);

  const [activeLink, setActiveLink] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Get the current location using useLocation hook

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Get the current URL pathname
    const currentUrlPathname = window.location.pathname;

    // Set the active link based on the current URL pathname
    setActiveLink(currentUrlPathname);
  }, []);

  useEffect(() => {
    if (openClose) {
      document.body.style.overflowY = "hidden";
      document.body.style.height = "100vh";
    } else {
      document.body.style.overflowY = "initial";
      document.body.style.height = "initial";
    }
  }, [openClose]);

  useEffect(() => {
    if (isDarkMode) {
      if (document.body.classList.contains("light")) {
        document.body.classList.remove("light");
      }
      document.body.classList.add("dark");
    } else {
      if (document.body.classList.contains("dark")) {
        document.body.classList.remove("dark");
      }
      document.body.classList.add("light");
    }
  }, [isDarkMode]);

  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const sections = [
      "about",
      "tokenomics",
      "work",
      "roadmap",
      "team",
      "partners",
    ]; // Add more section IDs if needed
    const observer = new IntersectionObserver(
      (entries) => {
        let foundActive = false;

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
            foundActive = true;
          }
        });

        // Default to "home" only if no other section is active
        if (!foundActive) {
          setActiveSection("home");
        }
      },
      {
        root: null, // Viewport as the container
        rootMargin: "0px", // No margin
        threshold: 0.5, // Adjust as needed
      }
    );

    sections.forEach((id) => {
      const target = document.getElementById(id);
      if (target) observer.observe(target);
    });

    return () => {
      sections.forEach((id) => {
        const target = document.getElementById(id);
        if (target) observer.unobserve(target);
      });
    };
  }, []);

  document.addEventListener("scroll", () => {
    const navigation = document.querySelector(".navigation-wrapper")!;
    if (window.scrollY > 0) {
      navigation.classList.add("scrolled");
    } else {
      navigation.classList.remove("scrolled");
    }
  });

  return (
    <div className="navigation-wrapper">
      <div className="mx">
        <div className="desktophead">
          <div>
            {" "}
            <img src={Loogo} className="logoo" />
          </div>
          <div className="site-nav">
            {" "}
            <nav className="site-navigation">
              <ul className="nav">
                <li>
                  <Link
                    to="/"
                    className={`navlink ${
                      location.pathname === '/' ? "active" : ""
                    }`}
                  >
                    Home
                  </Link>
                </li>
                
                {/* <li>
      <Link
    to="./#ecosystem"
    className={`navlink ${activeSection === "ecosystem" ? "active" : ""}`}
    onClick={() => {
      const section = document.querySelector("./#ecosystem");
      section?.scrollIntoView({ behavior: "smooth" });
    }}
  >
    Ecosystem
  </Link>
      </li> */}

                <li>
                  <Link
                    to="./#why"
                    className={`navlink ${
                      activeSection === "why" ? "active" : ""
                    }`}
                    onClick={() => {
                      const section = document.querySelector("#why");
                      section?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    Why Choose Us ?
                  </Link>
                </li>

                <li>
                  <a
                    href="./#plans"
                    className="navlink"
                    onClick={(e) => {
                      e.preventDefault();
                      if (location.pathname === '/') {
                        // Already on home page, just scroll to section
                        const section = document.querySelector("#plans");
                        section?.scrollIntoView({ behavior: "smooth" });
                      } else {
                        // Not on home page, navigate to home first then scroll
                        navigate('/');
                        setTimeout(() => {
                          const section = document.querySelector("#plans");
                          section?.scrollIntoView({ behavior: "smooth" });
                        }, 500);
                      }
                    }}
                  >
                    Plans
                  </a>
                </li>

                <li>
                  <a
                    href="./#faq"
                    className="navlink"
                    onClick={(e) => {
                      e.preventDefault();
                      if (location.pathname === '/') {
                        // Already on home page, just scroll to section
                        const section = document.querySelector("#faq");
                        section?.scrollIntoView({ behavior: "smooth" });
                      } else {
                        // Not on home page, navigate to home first then scroll
                        navigate('/');
                        setTimeout(() => {
                          const section = document.querySelector("#faq");
                          section?.scrollIntoView({ behavior: "smooth" });
                        }, 500);
                      }
                    }}
                  >
                    FAQs
                  </a>
                </li>

                <li>
                  <Link
                    to="./testimonials"
                    className={`navlink ${location.pathname === '/testimonials' || location.pathname === './testimonials' ? 'active' : ''}`}
                  >
                    Testimonials
                  </Link>
                </li>

               

                {/* <li>
                  <Link
                    to="./#partners"
                    className={`navlink ${
                      activeSection === "partners" ? "active" : ""
                    }`}
                    onClick={() => {
                      const section = document.querySelector("#partners");
                      section?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    Partners
                  </Link>
                </li> */}

               
              </ul>
            </nav>
          </div>

          
          <div > 
            
            <button   onClick={() => window.location.href = "https://users.tradesimple.ca/signup"}
 className={`button-prim `}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: 0,
                  padding: 0,
                }}
              >
                Sign Up / Login
              </div>
            </button>{" "}
          </div>
        </div>

        <div className="mobilehead">
          <div>
            {" "}
            <img src={Loogo} className="logoo"   />
          </div>

          <div>
          
          </div>
          <div>
            {" "}
            <div
              className="circlebg newmwnu"
              onClick={() => setOpenClose((m) => !m)}
            >
              <MenuIcon />
            </div>
          </div>
        </div>
        <AnimatePresence>
          {openClose && (
            <motion.div
              className="sidebar-backdrop"
              onClick={() => setOpenClose(false)}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              initial={{ opacity: 0 }}
            >
              <motion.div
                className="bar"
                onClick={(e: any) => e.stopPropagation()}
                animate={{ right: 0, transitionDelay: "-200ms" }}
                exit={{ right: -300 }}
                initial={{ right: -300 }}
              >
                <div className="header-side-bar">
                  <div
                    className="close-icon"
                    onClick={() => setOpenClose(false)}
                  >
                    <Close />
                  </div>

                  <div style={{ flex: 1 }}>
                    <nav>
                      <NavLink
                        to="./#home"
                        className="list flex-item"
                        onClick={() => {
                          const section = document.querySelector("#home");
                          section?.scrollIntoView({ behavior: "smooth" });
                          setOpenClose(false);
                        }}
                      >
                        <span>Home</span>
                      </NavLink>
                    
                    
               

                      <NavLink
                        to="./#why"
                        className="list flex-item"
                        onClick={() => {
                          const section = document.querySelector("#why");
                          section?.scrollIntoView({ behavior: "smooth" });
                          setOpenClose(false);
                        }}
                      >
                        <span>Why Choose Us ?</span>
                      </NavLink>

                      <a
                        href="./#plans"
                        className="list flex-item"
                        onClick={(e) => {
                          e.preventDefault();
                          if (location.pathname === '/') {
                            // Already on home page, just scroll to section
                            const section = document.querySelector("#plans");
                            section?.scrollIntoView({ behavior: "smooth" });
                          } else {
                            // Not on home page, navigate to home first then scroll
                            navigate('/');
                            setTimeout(() => {
                              const section = document.querySelector("#plans");
                              section?.scrollIntoView({ behavior: "smooth" });
                            }, 500);
                          }
                          setOpenClose(false);
                        }}
                      >
                        <span> Plans</span>
                      </a>

                      <a
                        href="./#faq"
                        className="list flex-item"
                        onClick={(e) => {
                          e.preventDefault();
                          if (location.pathname === '/') {
                            // Already on home page, just scroll to section
                            const section = document.querySelector("#faq");
                            section?.scrollIntoView({ behavior: "smooth" });
                          } else {
                            // Not on home page, navigate to home first then scroll
                            navigate('/');
                            setTimeout(() => {
                              const section = document.querySelector("#faq");
                              section?.scrollIntoView({ behavior: "smooth" });
                            }, 500);
                          }
                          setOpenClose(false);
                        }}
                      >
                        <span>FAQs</span>
                      </a>

                      <NavLink
                        to="./testimonials"
                        className={`list flex-item ${location.pathname === '/testimonials' || location.pathname === './testimonials' ? 'active' : ''}`}
                        onClick={() => {
                          setOpenClose(false);
                        }}
                      >
                        <span>Testimonials</span>
                      </NavLink>

                    
                      

                    </nav>
                    <div className="allChains"></div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Navigation;
